import styled from 'styled-components';
import { Grid } from '@material-ui/core';
import { constants } from '@cambridgeassessment/cambridge-ui';

export const StyledGridItem = styled(Grid)`
  align-content: flex-start;
  padding-bottom: 32px;
  padding-right: 16px;
  line-height: 1.5;
  * {
    font-size: ${constants.LARGE};
    font-family: ${constants.blissPro};
    font-weight: bold;
  }
`;

export const StyledGridItemDescription = styled.div`
  width: 100%;
  font-weight: normal;
  font-family: ${constants.sourceSansPro};
  font-size: ${constants.MEDIUM};
  line-height: 1.5;
`;
